module.exports = __webpack_public_path__ + "static/media/YF98_2.0ab87c41.jpg";